import { useContext } from 'react'
import { TranslatorContext } from './provider'

export const useTranslator = () => {
  return useContext(TranslatorContext)
}
